import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Translatable from './Translatable';
import Heading from '../heading/Heading';

const MessagePage = ({ title, level, messageId, textClass }) => (
    <Fragment >
        <Heading text={title} level={level} center />
        <Translatable message={messageId} className={textClass} />
    </Fragment >
    );

MessagePage.defaultProps = ({
    level: '3',
    textClass: '',
});

MessagePage.propTypes = ({
    title: PropTypes.string.isRequired,
    level: PropTypes.string,
    messageId: PropTypes.string.isRequired,
    textClass: PropTypes.string,
});

export default MessagePage;



// WEBPACK FOOTER //
// ./src/components/common/MessagePage.js